/* eslint-disable max-lines-per-function */
/* eslint-disable no-await-in-loop */
/* eslint-disable complexity */
/**
 * Enhances Swish wishlist cards to match main collection product-item layout:
 * meta order (title → author → publishing → collections → price), missing.svg overlay,
 * quick-buy / BIS actions. Uses themeVariables routes; quick-buy uses fetch like theme ProductForm.
 */
(function () {
	const LAYOUT_CHECK_DEBOUNCE_MS = 200;
	const LAYOUT_EMPTY_GRID_MS = 900;
	const LAYOUT_FAILSAFE_MS = 15000;

	let wishlistLayoutCheckTimer = null;
	let wishlistLayoutFailsafeTimer = null;

	function clearWishlistLayoutFailsafe() {
		if (wishlistLayoutFailsafeTimer !== null) {
			clearTimeout(wishlistLayoutFailsafeTimer);
			wishlistLayoutFailsafeTimer = null;
		}
	}

	function revealWishlistLayout() {
		clearWishlistLayoutFailsafe();
		document.documentElement.classList.remove('boa-wishlist-layout-loading');
		document.documentElement.classList.add('boa-wishlist-layout-ready');
	}

	function checkWishlistLayoutReady() {
		const cards = [...document.querySelectorAll('wishlist-product-card')];
		if (cards.length === 0) {
			return;
		}
		if (cards.some((card) => card.dataset.boaWishlistBusy === '1')) {
			return;
		}
		const allSettled = cards.every(
			(card) =>
				card.dataset.boaWishlistEnhanced === '1' || card.dataset.boaWishlistEnhanceFailed === '1'
		);
		if (!allSettled) {
			return;
		}
		revealWishlistLayout();
	}

	function markWishlistLayoutCheck() {
		if (wishlistLayoutCheckTimer !== null) {
			clearTimeout(wishlistLayoutCheckTimer);
		}
		wishlistLayoutCheckTimer = setTimeout(() => {
			wishlistLayoutCheckTimer = null;
			checkWishlistLayoutReady();
		}, LAYOUT_CHECK_DEBOUNCE_MS);
	}

	function startWishlistLayoutFailsafe() {
		clearWishlistLayoutFailsafe();
		wishlistLayoutFailsafeTimer = setTimeout(() => {
			wishlistLayoutFailsafeTimer = null;
			revealWishlistLayout();
		}, LAYOUT_FAILSAFE_MS);
	}

	function scheduleEmptyWishlistReveal() {
		setTimeout(() => {
			if (document.documentElement.classList.contains('boa-wishlist-layout-ready')) {
				return;
			}
			const grid = document.querySelector('.wk-grid');
			const cardCount = document.querySelectorAll('wishlist-product-card').length;
			if (grid && cardCount === 0) {
				revealWishlistLayout();
			}
		}, LAYOUT_EMPTY_GRID_MS);
	}

	const QUICK_BUY_SVG =
		'<svg width="800px" height="800px" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:sketch="http://www.bohemiancoding.com/sketch/ns"><g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" sketch:type="MSPage"><g id="Icon-Set-Filled" sketch:type="MSLayerGroup" transform="translate(-466.000000, -1089.000000)"><circle cx="482" cy="1105" r="16" fill="#f7dc6b"/><g fill="#231f20"><rect x="476" y="1104" width="12" height="2" rx="1"/><rect x="481" y="1099" width="2" height="12" rx="1"/></g></g></g></svg>';

	const BIS_ARROW_SVG =
		'<svg xmlns="http://www.w3.org/2000/svg" focusable="false" width="26" height="26" viewBox="0 0 58.2 58.2"><polygon points="7.7 27.4 8.14 29.91 14.35 35.31 17.08 33.79 12.3 28.92 16.72 23.43 14.62 21.91 7.7 27.4"/><path d="M33.32,46.32c-2.12-3.21-5.98-9.47-5.98-17.34,0-7.75,3.09-13.89,5.98-17.46l2.73,1.04c-2.29,2.65-5.54,8.87-5.54,16.22,0,7.27,3.89,13.97,5.54,16.54l-2.73,1Z"/><path d="M21.98,30.22c-2.91.17-6.17.41-9.02.59l-2.3-4.43,11.38.69,3.51.04,22.58-.66,1.94,4.4-24.57-.66-3.51.03Z"/></svg>';

	const CART_ADD_QUICK_BUY_FIELDS_TEMPLATE = (() => {
		const template = document.createElement('template');
		template.innerHTML = [
			'<input type="hidden" name="form_type" value="product">',
			'<input type="hidden" name="utf8" value="✓">',
			'<input type="hidden" name="quantity" value="1">',
			'<input type="hidden" name="id" value="">',
			'<button type="submit" class="product-item__quick-buy-button">',
			'<span class="visually-hidden">הוספה לסל</span>',
			'</button>',
		].join('');
		return template;
	})();

	const BIS_TRIGGER_ROW_TEMPLATE = (() => {
		const template = document.createElement('template');
		template.innerHTML = [
			'<a href="#" class="BIS_trigger button-out-of-stock">',
			'<span class="BIS_trigger"></span>',
			'<span class="BIS_trigger"></span>',
			'</a>',
		].join('');
		return template;
	})();

	const MISSING_BOOK_OVERLAY_TEMPLATE = (() => {
		const template = document.createElement('template');
		template.innerHTML =
			'<div class="product-item__missing-overlay"><img class="product-item__missing-overlay-img" alt="" src=""></div>';
		return template;
	})();

	function handleFromHref(href) {
		try {
			const parsedUrl = new URL(href, window.location.origin);
			const pathMatch = parsedUrl.pathname.match(/\/products\/([^/?#]+)/);
			return pathMatch ? decodeURIComponent(pathMatch[1]) : null;
		} catch {
			return null;
		}
	}

	function parsePriceNum(raw) {
		if (raw === null || raw === '') {
			return null;
		}
		const parsedNumber = parseFloat(String(raw).replace(/[^\d.]/g, ''));
		return Number.isFinite(parsedNumber) ? parsedNumber : null;
	}

	/** Shopify /products/{handle}.js uses minor currency units (e.g. agorot) on variants. */
	function shopifyMinorToMajor(raw) {
		const parsedNumber = parsePriceNum(raw);
		if (parsedNumber === null) {
			return null;
		}
		return parsedNumber / 100;
	}

	async function fetchProductJson(handle) {
		const res = await fetch(`/products/${handle}.js`);
		if (!res.ok) {
			return null;
		}
		return res.json();
	}

	async function fetchBookRecord(handle, title) {
		for (const term of [handle, title].filter(Boolean)) {
			try {
				const res = await fetch('/tools/proxy/api/books/search', {
					method: 'POST',
					headers: { 'Content-Type': 'application/json' },
					body: JSON.stringify({ searchTerm: term, page: 1 }),
				});
				if (!res.ok) {
					continue;
				}
				const json = await res.json();
				const rows = json.data || [];
				const exact = rows.find((book) => book.handle === handle);
				if (exact) {
					return exact;
				}
				if (rows.length === 1) {
					return rows[0];
				}
			} catch {
				/* Ignore */
			}
		}
		return null;
	}

	function featuredImageUrl(product) {
		const image = product.featured_image || (product.images && product.images[0]);
		if (!image) {
			return '';
		}
		const src = typeof image === 'string' ? image : image.src;
		if (!src) {
			return '';
		}
		return src.split('?')[0] + '?width=600';
	}

	function buildBisPayload(product, book, vendorFallback) {
		const author = (book && book.author) || product.type || '';
		const publisher =
			(book && book.publishing) ||
			product.vendor ||
			(vendorFallback ? vendorFallback.split(',')[0].trim() : '');
		let yearPublication = (book && book.yearPublication) || '';
		if (!yearPublication && vendorFallback) {
			const yearMatches = vendorFallback.match(/(\d{4})/g);
			if (yearMatches && yearMatches.length) {
				yearPublication = yearMatches[yearMatches.length - 1];
			}
		}
		const firstVariant = product.variants && product.variants[0];
		return JSON.stringify({
			id: product.id,
			title: product.title,
			handle: product.handle,
			available: false,
			tags: product.tags || [],
			author: author || null,
			publisher: publisher || null,
			image: featuredImageUrl(product) || null,
			yearPublication: yearPublication || undefined,
			variants: [
				{
					id: firstVariant && firstVariant.id,
					title: product.title,
					available: false,
					inventory_quantity: 0,
					inventory_management: 'shopify',
				},
			],
		});
	}

	function formatMoneyish(amountMajor) {
		if (amountMajor == null || amountMajor === '') {
			return '';
		}
		const parsedNumber =
			typeof amountMajor === 'number' ? amountMajor : parseFloat(String(amountMajor));
		if (!Number.isFinite(parsedNumber)) {
			return String(amountMajor);
		}
		return parsedNumber.toFixed(2);
	}

	/** In-stock only: sellable variants (no price markup when product is unavailable). */
	function buildPriceHtml(product) {
		const variants = product.variants || [];
		const pool = variants.filter((variant) => variant.available);
		const sorted = [...pool].sort(
			(a, b) => (parsePriceNum(a.price) || 0) - (parsePriceNum(b.price) || 0)
		);
		const low = sorted[0];
		const high = sorted[sorted.length - 1];

		if (!product.available || !pool.length) {
			return '';
		}

		const lowMajor = low ? shopifyMinorToMajor(low.price) : null;
		const highMajor = high ? shopifyMinorToMajor(high.price) : null;

		if (lowMajor !== null && highMajor !== null && lowMajor !== highMajor) {
			return `<span class="price price--highlight price--large">${formatMoneyish(lowMajor)} ₪ - ${formatMoneyish(highMajor)} ₪</span>`;
		}

		const variant = low || variants[0];
		const price = variant ? shopifyMinorToMajor(variant.price) : shopifyMinorToMajor(product.price);
		const compare = variant ? shopifyMinorToMajor(variant.compare_at_price) : null;
		if (compare !== null && price !== null && compare > price) {
			return `<span class="price price--highlight price--large">${formatMoneyish(price)} ₪</span><span class="price price--compare">${formatMoneyish(compare)} ₪</span>`;
		}
		if (price !== null) {
			return `<span class="price price--highlight price--large">${formatMoneyish(price)} ₪</span>`;
		}
		return `<span class="price price--large">לא זמין</span>`;
	}

	function setAspectOnImageLink(link, product) {
		const firstImage = product.images && product.images[0];
		const aspectRatio =
			firstImage && firstImage.aspect_ratio ? Number(firstImage.aspect_ratio) : 2 / 3;
		link.classList.add('product-item__aspect-ratio', 'aspect-ratio');
		link.style.setProperty('--aspect-ratio', String(aspectRatio));
		const paddingPercent = 100 / aspectRatio;
		link.style.paddingBottom = `${paddingPercent}%`;
		const imageElement = link.querySelector('.wk-image');
		if (imageElement) {
			imageElement.classList.add('product-item__primary-image');
		}
	}

	function wrapImage(card, product) {
		const link = card.querySelector('a.wk-image-link');
		if (!link || link.closest('.boa-wishlist__image-wrap')) {
			return null;
		}
		const wrap = document.createElement('div');
		wrap.className = 'boa-wishlist__image-wrap product-item__image-wrapper';
		link.parentNode.insertBefore(wrap, link);
		wrap.appendChild(link);
		setAspectOnImageLink(link, product);
		return wrap;
	}

	function addMissingOverlay(imageWrap) {
		const missingSvgHost = document.querySelector('.missing-book-svg[data-missing-svg-url]');
		const missingUrl = missingSvgHost?.dataset.missingSvgUrl;
		if (!missingUrl) {
			return;
		}
		const fragment = MISSING_BOOK_OVERLAY_TEMPLATE.content.cloneNode(true);
		const overlay = fragment.querySelector('.product-item__missing-overlay');
		const image = fragment.querySelector('img');
		if (image) {
			image.src = missingUrl;
		}
		if (overlay) {
			imageWrap.insertBefore(overlay, imageWrap.firstChild);
		}
	}

	/** Swish Lit can re-render and drop our nodes while data-boa-wishlist-enhanced stays set. */
	function cleanupStaleWishlistEnhance(card) {
		delete card.dataset.boaWishlistEnhanceFailed;
		const shell = card.querySelector('.wk-product-card');
		shell?.classList.remove('boa-wishlist--enhanced');

		const meta = card.querySelector('.wk-meta');
		if (meta) {
			meta.querySelectorAll(':scope > .author-and-publishing-wrap').forEach((el) => el.remove());
			meta.querySelectorAll(':scope > .collections-wrap').forEach((el) => el.remove());
			const priceContainer = meta.querySelector(
				':scope > .product-item-meta__price-list-container'
			);
			if (priceContainer) {
				const placeholder = document.createElement('div');
				placeholder.className = 'wk-price';
				priceContainer.replaceWith(placeholder);
			}
			meta.classList.remove('product-item-meta');
		}

		const wrap = card.querySelector('.boa-wishlist__image-wrap');
		if (wrap?.parentNode) {
			const link = wrap.querySelector('a.wk-image-link');
			if (link) {
				link.classList.remove('product-item__aspect-ratio', 'aspect-ratio');
				link.style.paddingBottom = '';
				link.style.removeProperty('--aspect-ratio');
				const wishlistImage = link.querySelector('.wk-image');
				wishlistImage?.classList.remove('product-item__primary-image');
				wrap.parentNode.insertBefore(link, wrap);
			}
			wrap.remove();
		}

		card.querySelector('.wk-form')?.classList.remove('boa-wishlist__wk-form--hidden');
	}

	/**
	 * Mirrors theme `ProductForm._onSubmit` (fetch `cartAddUrl.js`, sections, cart:refresh).
	 * Plain form + this handler avoids native POST to `/cart/add` when `is="product-form"` does not run.
	 * On `/apps/wishlist`, do not treat `pageType === 'cart'` as “go to cart” (avoids false redirects off PDP).
	 */
	async function submitWishlistQuickBuyForm(form) {
		if (!form.checkValidity()) {
			form.reportValidity();
			return;
		}
		const submitButtons = Array.from(form.elements).filter((button) => button.type === 'submit');
		submitButtons.forEach((button) => {
			button.setAttribute('disabled', 'disabled');
			button.setAttribute('aria-busy', 'true');
		});
		const productForm = new FormData(form);
		productForm.append('sections', 'mini-cart');
		productForm.delete('option1');
		productForm.delete('option2');
		productForm.delete('option3');
		const cartAddUrl = window.themeVariables?.routes?.cartAddUrl || '/cart/add';
		try {
			const response = await fetch(`${cartAddUrl}.js`, {
				body: productForm,
				method: 'POST',
				headers: { 'X-Requested-With': 'XMLHttpRequest' },
			});
			submitButtons.forEach((button) => {
				button.removeAttribute('disabled');
				button.removeAttribute('aria-busy');
			});
			const responseJson = await response.json();
			if (response.ok) {
				const onWishlist = window.location.pathname.includes('/apps/wishlist');
				const goCartPage =
					window.themeVariables?.settings?.cartType === 'page' ||
					(!onWishlist && window.themeVariables?.settings?.pageType === 'cart');
				if (goCartPage) {
					window.location.href = `${window.Shopify?.routes?.root || '/'}cart`;
					return;
				}
				form.dispatchEvent(
					new CustomEvent('variant:added', {
						bubbles: true,
						detail: {
							variant: Object.prototype.hasOwnProperty.call(responseJson, 'items')
								? responseJson.items[0]
								: responseJson,
						},
					})
				);
				const cartUrl = window.themeVariables?.routes?.cartUrl || '/cart';
				fetch(`${cartUrl}.js`).then(async (cartResponse) => {
					const cartContent = await cartResponse.json();
					document.documentElement.dispatchEvent(
						new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cartContent } })
					);
					cartContent.sections = responseJson.sections;
					document.documentElement.dispatchEvent(
						new CustomEvent('cart:refresh', {
							bubbles: true,
							detail: {
								cart: cartContent,
								openMiniCart:
									window.themeVariables?.settings?.cartType === 'drawer' &&
									form.closest('.drawer') === null,
							},
						})
					);
				});
			}
			form.dispatchEvent(
				new CustomEvent('cart-notification:show', {
					bubbles: true,
					cancelable: true,
					detail: {
						status: response.ok ? 'success' : 'error',
						error: responseJson.description || '',
					},
				})
			);
		} catch {
			submitButtons.forEach((button) => {
				button.removeAttribute('disabled');
				button.removeAttribute('aria-busy');
			});
		}
	}

	/** Swish single-variant rows often keep an enabled `wk-form` POST to `/cart/add` → full page cart. */
	let wishlistSwishSubmitBlockInstalled = false;
	function installWishlistSwishSubmitBlock() {
		if (wishlistSwishSubmitBlockInstalled) {
			return;
		}
		wishlistSwishSubmitBlockInstalled = true;
		document.addEventListener(
			'submit',
			(event) => {
				if (!window.location.pathname.includes('/apps/wishlist')) {
					return;
				}
				const submitTarget = event.target;
				if (
					submitTarget instanceof HTMLFormElement &&
					submitTarget.classList.contains('wk-form') &&
					submitTarget.classList.contains('boa-wishlist__wk-form--hidden')
				) {
					event.preventDefault();
					event.stopImmediatePropagation();
				}
			},
			true
		);
	}

	/** Quick-buy form; variant = first available, else first (covers multi-variant SKUs). Plain form + JS submit. */
	function insertSingleVariantQuickBuy(imageWrap, product) {
		if (imageWrap.querySelector('.product-item__quick-form')) {
			return;
		}
		const selectedVariant =
			product.variants.find((variant) => variant.available) || product.variants[0];
		if (!selectedVariant) {
			return;
		}
		const uid =
			typeof crypto !== 'undefined' && crypto.randomUUID
				? crypto.randomUUID().replace(/-/g, '').slice(0, 12)
				: String(Date.now());
		const formId = `product_form_boa_wishlist_${product.id}_${uid}`;
		const form = document.createElement('form');
		form.method = 'post';
		form.action = '/cart/add';
		form.className = 'product-item__quick-form';
		form.setAttribute('accept-charset', 'UTF-8');
		form.setAttribute('enctype', 'multipart/form-data');
		form.id = formId;
		form.dataset.boaWishlistQuickBuy = '1';

		form.appendChild(CART_ADD_QUICK_BUY_FIELDS_TEMPLATE.content.cloneNode(true));
		const variantIdInput = form.querySelector('input[name="id"]');
		if (variantIdInput) {
			variantIdInput.value = String(selectedVariant.id);
		}
		const buyButton = form.querySelector('button.product-item__quick-buy-button');
		if (buyButton) {
			buyButton.insertAdjacentHTML('beforeend', QUICK_BUY_SVG);
		}
		form.addEventListener('submit', (event) => {
			event.preventDefault();
			void submitWishlistQuickBuyForm(form);
		});
		imageWrap.appendChild(form);
	}

	function replacePriceAndBis(meta, product, book, vendorText, oos) {
		const priceHost = meta.querySelector('.wk-price');
		if (!priceHost) {
			return;
		}

		const container = document.createElement('div');
		container.className = 'product-item-meta__price-list-container';
		const list = document.createElement('div');
		list.className = 'price-list price-list--centered';

		if (!oos) {
			const priceHtml = buildPriceHtml(product);
			if (priceHtml) {
				list.insertAdjacentHTML('beforeend', priceHtml);
			}
		}

		if (oos) {
			const data = buildBisPayload(product, book, vendorText);
			const fragment = BIS_TRIGGER_ROW_TEMPLATE.content.cloneNode(true);
			const bisLink = fragment.querySelector('a');
			const bisSpans = fragment.querySelectorAll('span');
			if (bisLink && bisSpans.length >= 2) {
				bisLink.setAttribute('data-product-data', data);
				bisSpans[0].setAttribute('data-product-data', data);
				bisSpans[0].textContent = 'צודו לי';
				bisSpans[1].setAttribute('data-product-data', data);
				bisSpans[1].innerHTML = BIS_ARROW_SVG;
				list.appendChild(bisLink);
			}
		}

		container.appendChild(list);
		priceHost.replaceWith(container);
	}

	async function enhanceCard(card) {
		let started = false;
		try {
			const imgLink = card.querySelector('a.wk-image-link');
			if (!imgLink) {
				return;
			}

			if (card.dataset.boaWishlistEnhanced === '1') {
				const intact = Boolean(imgLink.closest('.boa-wishlist__image-wrap'));
				if (intact) {
					return;
				}
				cleanupStaleWishlistEnhance(card);
				delete card.dataset.boaWishlistEnhanced;
				delete card.dataset.boaWishlistEnhanceFailed;
			}

			if (card.dataset.boaWishlistBusy === '1') {
				return;
			}
			const imageLink = card.querySelector('a.wk-image-link');
			if (!imageLink) {
				return;
			}
			const handle = handleFromHref(imageLink.getAttribute('href'));
			if (!handle) {
				return;
			}

			card.dataset.boaWishlistBusy = '1';
			started = true;

			let product;
			try {
				product = await fetchProductJson(handle);
			} catch {
				return;
			}
			if (!product) {
				return;
			}

			const book = await fetchBookRecord(handle, product.title);
			const shell = card.querySelector('.wk-product-card');
			if (!shell) {
				return;
			}
			shell.classList.add('boa-wishlist--enhanced');

			const vendorEl = card.querySelector('.wk-vendor');
			let vendorText = '';
			if (vendorEl) {
				vendorText = vendorEl.textContent.trim();
				card.dataset.boaWishlistVendorBackup = vendorText;
				vendorEl.remove();
			} else {
				vendorText = card.dataset.boaWishlistVendorBackup || '';
			}

			const meta = card.querySelector('.wk-meta');
			const titleEl = card.querySelector('.wk-product-title');
			if (!meta || !titleEl) {
				return;
			}

			meta.classList.add('product-item-meta');

			const titleLink = titleEl.querySelector('.wk-text-link');
			if (titleLink) {
				titleLink.classList.add('product-item-meta__title');
			}

			const authorWrap = document.createElement('div');
			authorWrap.className = 'author-and-publishing-wrap';
			const authorName = (book && book.author) || product.type;
			if (authorName) {
				const authorLink = document.createElement('a');
				authorLink.className = 'author';
				authorLink.href = `/search?q=${encodeURIComponent(authorName)}`;
				authorLink.textContent = authorName;
				authorWrap.appendChild(authorLink);
			}
			const pubSpan = document.createElement('span');
			const pub = (book && book.publishing) || '';
			const yr = (book && book.yearPublication) || '';
			if (pub || yr) {
				pubSpan.textContent = [pub, yr].filter(Boolean).join(pub && yr ? ', ' : '');
			} else if (vendorText) {
				pubSpan.textContent = vendorText;
			}
			if (pubSpan.textContent) {
				authorWrap.appendChild(pubSpan);
			}

			let blockAfterTitle = titleEl;
			if (authorWrap.childNodes.length) {
				titleEl.insertAdjacentElement('afterend', authorWrap);
				blockAfterTitle = authorWrap;
			}

			if (book && book.collections && book.collections.length) {
				const collectionsWrap = document.createElement('div');
				collectionsWrap.className = 'collections-wrap';
				book.collections.slice(0, 2).forEach((collection, index) => {
					const collectionLink = document.createElement('a');
					collectionLink.href = collection.link || '#';
					collectionLink.className = 'collection-link';
					collectionLink.textContent = collection.name || '';
					collectionsWrap.appendChild(collectionLink);
					if (index < Math.min(book.collections.length, 2) - 1) {
						const separator = document.createElement('span');
						separator.className = 'collection-separator';
						separator.textContent = ', ';
						collectionsWrap.appendChild(separator);
					}
				});
				blockAfterTitle.insertAdjacentElement('afterend', collectionsWrap);
			}

			const oos = !product.available;
			replacePriceAndBis(meta, product, book, vendorText, oos);

			const imageWrap = wrapImage(card, product);
			if (imageWrap && oos) {
				addMissingOverlay(imageWrap);
			}

			const form = card.querySelector('.wk-form');
			if (form) {
				form.classList.add('boa-wishlist__wk-form--hidden');
			}

			if (imageWrap && !oos) {
				insertSingleVariantQuickBuy(imageWrap, product);
			}

			card.dataset.boaWishlistEnhanced = '1';
		} catch {
			if (started) {
				card.dataset.boaWishlistEnhanceFailed = '1';
			}
		} finally {
			if (started) {
				delete card.dataset.boaWishlistBusy;
				if (card.dataset.boaWishlistEnhanced !== '1') {
					card.dataset.boaWishlistEnhanceFailed = '1';
				}
			}
			markWishlistLayoutCheck();
		}
	}

	let scheduled = null;

	function runQueue() {
		scheduled = null;
		document.querySelectorAll('wishlist-product-card').forEach((card) => {
			enhanceCard(card);
		});
		markWishlistLayoutCheck();
	}

	function schedule() {
		if (scheduled !== null) {
			return;
		}
		scheduled = window.requestAnimationFrame(runQueue);
	}

	installWishlistSwishSubmitBlock();

	startWishlistLayoutFailsafe();
	scheduleEmptyWishlistReveal();

	const mo = new MutationObserver(schedule);
	mo.observe(document.body, { childList: true, subtree: true });
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', schedule);
	} else {
		schedule();
	}
})();
